export const PAGE_OPTIONS = [10 , 50, 100];
export const PER_PAGE = 10;
